<template>
<div>
    <el-row>
        <el-col :span="8" class="filter-layout-text-left">
            <span>Ship Flow</span>
        </el-col>
        <el-col :span="16" class="filter-layout-text">
            <el-select
            v-model="searchText"
            filterable
            placeholder="ค้นหา"
            class="ship-flow-filter-kan-style"
            remote
            clearable
            reserve-keyword
            :loading="loading"
            :remote-method="remoteSearch"
            @change="handleSelect"
            @focus="$event.target.select()">
                <el-option-group
                v-for="group in options"
                :key="group.label"
                >
                <el-option
                    v-for="item in group.options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
                </el-option-group>
            </el-select>
            &nbsp;
            <el-button :disabled="!statusChangeable" size="medium" @click="courierBookingStatusChange"><span style="color: #2C3E50; font-family: Sarabun; font-size: 16px;">เปลี่ยนสถานะ</span></el-button>
            <el-button :disabled="!confirmableCheck" class="confirm-btn-style" size="medium" @click="confirmCourierBooking"><span style="font-family: Sarabun; font-size: 16px; font-weight: bold;">Confirm</span></el-button>
        </el-col>
    </el-row>
    <confirm-dialog :detail="confirmInfo"/>
</div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import { eventBus } from '@/main'
import confirmDialog from '@/components/Booking/BookingDialog/BookingDialogConfirm.vue'
export default {
    components: {
        confirmDialog
    },
    props: {
        modeCheck: {
            type: Number
        }
    },
    data () {
        return {
            links: [],
            searchText: '',
            options: [],
            loading: false,
            confirmInfo: {
                dialog: false
            }
        }
    },
    computed: {
        confirmableCheck () {
            return this.modeCheck === 2 || this.modeCheck === 3
        },
        statusChangeable () {
            return this.modeCheck === 3 || this.modeCheck === 4
        }
    },
    methods: {
        async remoteSearch (query) {
            this.loading = true
            this.options = []
            console.log('query', query)
            this.timeoutSearch = setTimeout(async () => {
                let param = {
                    search: query
                }
                try {
                    let res = await fgApi.user.searchUserAndShop(param)
                    console.log('res', res)
                    if (res.success) {
                        let searchResult = []
                        res.data.forEach(e => {
                            let shopList = this.setSearchOption(e.shops, e.user_code)
                            searchResult.push({
                                label: e.user_code,
                                options: shopList
                            })
                        })
                        this.options = searchResult
                        console.log('this.options', this.options)
                    }
                } catch (error) {
                    console.log(error)
                }
                this.loading = false
            }, 200)
            // this.loading = false
        },
        setSearchOption (dataArr, userCode) {
            let searchOptionArr = []
            // console.log('dataArr', dataArr)
            searchOptionArr.push({
                value: userCode,
                label: userCode
            })
            for (let index in dataArr) {
                searchOptionArr.push({
                    value: dataArr[index].shop_id,
                    label: `${dataArr[index].shop_name}`
                })
            }
            return searchOptionArr
        },
        confirmCourierBooking () {
            let selectedRow = this.$store.get('booking/shipFlowSelected')
            if (selectedRow.length > 0) {
                this.confirmInfo.dialog = true
            } else {
                this.$notify.error({
                    title: 'แจ้งเตือน',
                    message: 'กรุณาเลือกอย่างน้อย 1 รายการ'
                })
            }
        },
        courierBookingStatusChange () {
            let selectedRow = this.$store.get('booking/shipFlowSelected')
            if (selectedRow.length > 0) {
                eventBus.$emit('courierBookingStatusChange', {})
            } else {
                this.$notify.error({
                    title: 'แจ้งเตือน',
                    message: 'กรุณาเลือกอย่างน้อย 1 รายการ'
                })
            }
        },
        querySearch (queryString, cb) {
            var links = this.links
            var results = queryString ? links.filter(this.createFilter(queryString)) : links
            cb(results)
        },
        createFilter (queryString) {
            return (link) => {
                return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
            }
        },
        handleSelect (item) {
            console.log(item)
            eventBus.$emit('bookingSearch', { search: item })
        },
        handleIconClick (ev) {
            console.log(ev)
        }
    }
}
</script>

<style lang="scss" scoped>
  .my-autocomplete {
    li {
      line-height: normal;
      padding: 7px;

      .value {
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .link {
        font-size: 12px;
        color: #b4b4b4;
      }
    }
  }

  .filter-layout-text-left{
      text-align: left;
      font-size: 22px;
      .ship-flow-filter-kan-style{
            &::placeholder{
                font-family: Sarabun;
                font-size: 16px;
            }
      }
  }
  .filter-layout-text{
        text-align: end;
        .confirm-btn-style{
            background: #08A7A3;
            color: white;
        }
  }
//   .booking-search-style:first-child{
//       color: green !important;

//   }
</style>
<style scoped>
    ul li:first-child {
    color: #08A7A3;
    font-weight: bold;
    }
</style>
